import { isAppointmentActual, isAppointmentStatusGood } from '../is-appoinment-content-show';
import { AppointmentBannerResponse } from '../../../graphql/ecp-locator/models/ecp-profile.models';

export const getActiveAppointment = (appointments: AppointmentBannerResponse[] = []): AppointmentBannerResponse | undefined => {
  return appointments.find(
    appointment => isAppointmentActual(appointment.date)
      && isAppointmentStatusGood(appointment.status),
  );
};
